import {Controller} from "@/controllers/Controller";

/**
 * Controller for article API (ms-purchase) : catalogue des articles achetés et leurs statistiques de stock
 */
export class ArticleController extends Controller {

    static getAll(urlParams = "") {
        return this.requestBuilder("GET", `/purchase/articles${urlParams}`, true);
    }

    // Chaque article du catalogue avec ses quantités achetées, reçues, en stock et affectées à chaque dossier
    static getStats() {
        return this.requestBuilder("GET", `/purchase/articles/stats`, true);
    }

    static get(id) {
        return this.requestBuilder("GET", `/purchase/articles/${id}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST", `/purchase/articles`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/purchase/articles/${id}`, true, body);
    }

    static delete(id) {
        return this.requestBuilder("PATCH", `/purchase/articles/deactivate/${id}`, true);
    }
}
